export default "__VITE_ASSET__08b03e11__"